import { render, staticRenderFns } from "./switchTemplateTwoDialog.vue?vue&type=template&id=2176b88c&"
import script from "./switchTemplateTwoDialog.vue?vue&type=script&lang=js&"
export * from "./switchTemplateTwoDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchTemplateTwoDialog.vue?vue&type=style&index=0&id=2176b88c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports